export type LeadMethod = "WhatsApp" | "Email" | "Phone" | "Form";
export type LeadStatus = "New" | "Contacted" | "Follow Up" | "Closed";

export interface Lead {
  id: string;
  name: string;
  initials: string;
  email: string;
  phone: string;
  vehicle: string;
  method: LeadMethod;
  message: string;
  date: string;
  status: LeadStatus;
}

// No placeholder customer records are shown in the admin area.
export const LEADS: Lead[] = [];

export const leadStatusPill = (status: LeadStatus): string => {
  const styles: Record<LeadStatus, string> = {
    New: "bg-sky-100 text-sky-700",
    Contacted: "bg-amber-100 text-amber-700",
    "Follow Up": "bg-violet-100 text-violet-700",
    Closed: "bg-slate-100 text-slate-500",
  };
  return styles[status];
};
